import { TwcProduct } from '../../../../twc-products';

export const MVFR_FLIGHT_RULES_PRODUCT_DATA: TwcProduct = {
  id: 'mvfr',
  defaultProductId: 'flightrules-mvfr-boeing',
  productName: 'Weather-Flight-Rules-MVFR-TWC',
  label: 'MVFR',
  weatherType: 'FLT_RULES_MVFR',
  description: 'TWC product (raster, forecast) - Global MVFR Flight Conditions',
  series: 'Forecast',
  timeSlicePeriodInMinutes: 360,
  lodMax: 5,
  protocol: 'WebTile',
  forecastTimeSlicePeriod: 60,
  flightLevelProductIds: {},
  zOrder: 87
};
